import { Div, H1, P } from '@dnb/eufemia';
import classNames from 'classnames';
import { type JSX, PropsWithChildren, ReactNode } from 'react';

import style from './index.module.css';

type HeroHeaderProps = PropsWithChildren<{
  image: string;
  altText: string;
  heroText: string | undefined;
  wideHeader: boolean;
  heroSubtitle?: string;
  skeleton?: boolean;
  heroLeftComponent?: ReactNode;
}>;

const HeroHeader = ({
  image,
  heroText,
  wideHeader,
  heroSubtitle,
  children,
  skeleton = false,
  heroLeftComponent,
}: HeroHeaderProps): JSX.Element => {
  const titleLoading = skeleton && !heroText;

  return (
    <div className={style['HeroHeaderWrapper']} id="HeroHeader" style={{ backgroundImage: `url(${image})` }}>
      <div
        className={classNames(style['HeroTextContainer'], {
          [style['HeroTextContainerWide']!]: wideHeader,
        })}
      >
        <Div className={style['HeroText']}>
          {heroLeftComponent ?? (
            <>
              <H1 className={style['HeroHeading']} color="white" size="x-large" skeleton={titleLoading}>
                {titleLoading ? 'Loading...' : heroText}
              </H1>

              {heroSubtitle && <P weight="medium">{heroSubtitle}</P>}
            </>
          )}
        </Div>
        {children && <div>{children}</div>}
      </div>
    </div>
  );
};

export default HeroHeader;
